import React from 'react'
import { useLocation } from 'react-router-dom'
import { parse } from 'query-string'

export function FullscreenImage() {
  const location = useLocation()
  const { uri } = parse(location.search)

  return (
    <img style={{ maxWidth: '100%', maxHeight: '100%' }} src={uri} alt="" />
  )
}
